<template>
    <sticky @scrolled="setPinnedStatus">
        <div
            class="main-menu-container fixed-top"
            :class="{ 'is-transparent': isTransparent }"
            ref="container"
        >
            <nav id="main-menu" class="navbar navbar-expand-lg">
                <slot name="home_link" :logo-uri="logoUri"></slot>
                
                <multi-language
                    v-if="config_header.multilanguage"
                    :languages="config_header.multilanguage"
                ></multi-language>
               
                <button
                    class="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    aria-expanded="false"
                    :aria-label="lang.labels.toggle"
                    @click="toggle"
                >
                    <masked-image src="/img/icons/menu-toggle.svg"></masked-image>
                </button>

                <div class="collapse navbar-collapse" :class="{ show: active }">
                    <div>
                        <button class="close-menu" @click="toggle">
                            <img src="/img/icons/close.svg" alt="Chiudi menu" height="20" width="20">
                        </button>
                    
                        <slot name="links"></slot>
                    </div>
                </div>
            </nav>
        </div>
    </sticky>
</template>

<script>
import { throttle } from 'lodash'
import Sticky from './Sticky'
import MultiLanguageVue from './MultiLanguage.vue'

export default {
    components: {
        'sticky': Sticky,
        'multi-language' : MultiLanguageVue
    },

    props: {
        config_header: {
            type: Object,
            required: true,
        }     
    },

    data() {
        return {
            active: false,
            force_opaque: false,
            is_pinned: false,
            min_width: 976,
            showToggle: false,
        }
    },

    computed: {
        hasTransparentHeader() {
            let is_transparent = false

            let transparent_bodies = [
                'agencies-home',
                'evaluations',
                'evaluations-result',
                'home-residential',
                'home-industrial',
                'home-touristic',
                'home-constructions',
                'home-seohub',
                'virtual-tour',
                //'work-with-us-index',
                'sell-estate-index',
                'network-index',
                'home-showcase',
                'agencies-show-nosector',
                'agencies-show-region',
                // 'agencies-show',
                'agencies-city-nosector',
                'agencies-district-nosector',
                'agencies-province-nosector',
                'agencies-quarter-nosector',
                'agencies-show-region',
                'agencies-province',
                'advertising'
                
            ]

            transparent_bodies.forEach(body_class => {
                if(document.body.classList.contains(body_class)) {
                    is_transparent = true
                }
            })

            return is_transparent
        },

        isTransparent() {
            return this.hasTransparentHeader && ! this.is_pinned && ! this.force_opaque
        },

        lang() {
            return this.$root.lang.header ? this.$root.lang.header.main_menu : {labels: []}
        },

        logoUri() {
            let uri = '/img/logo/' + this.$root.network + '-' + this.$root.country

            if(this.is_pinned || ! this.isTransparent) {
                uri += '-color'
            }

            return uri + '.svg'
        },
    },

    created() {
        window.addEventListener(
            "resize",
            throttle(() => {
                this.checkIsActive()
            }, 500)
        )
 
        this.watchClickOutside()

        window.events.$on('force_opaque_header', () => {
            this.force_opaque = true
        })
    },

    watch: {
        $route() {
            this.close()
        },

        active(value) {
            if(value && this.$root.is_mobile) {
                document.body.classList.add('modal-open')
            }
            else {
                document.body.classList.remove('modal-open')
            }
        },
    },

    methods: {
        close() {
            this.active = false
        },

        checkIsActive() {
            this.active = window.innerWidth > this.min_width
            this.showToggle = this.active
        },

        setPinnedStatus(value) {
            this.is_pinned = value
        },

        toggle() {
            this.active = ! this.active
        },

        watchClickOutside() {
            window.addEventListener('click', e => {
                var container = document.getElementById('main-menu');

                if (! container.contains(e.target) && this.active) {
                    this.toggle()
                }
            })
        },
    },
}
</script>
